import { QueryClient } from "@tanstack/react-query";
import { Dispatch } from "redux";
import { replacePOSAlerts, genericErrorMessage } from "../state/root";
import { AlertVariants } from "../types/Alert";
import { ALERTS } from "../util/constants";

const useQueryClient = (dispatch: Dispatch) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        onError: (err) => {
          if (
            err instanceof Error &&
            err.message === ALERTS.ERRORS.CLIENT_NOT_FOUND_ERROR
          ) {
            dispatch(
              replacePOSAlerts({
                variant: AlertVariants.INFO,
                heading: ALERTS.ERRORS.CLIENT_NOT_FOUND_ERROR,
                alertClearTimeout: 3000,
              })
            );
          } else {
            dispatch(replacePOSAlerts(genericErrorMessage(err)));
          }
        },
        retry: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        cacheTime: 0,
      },
      mutations: {
        onError: (err) => {
          dispatch(replacePOSAlerts(genericErrorMessage(err)));
        },
      },
    },
  });

export default useQueryClient;
